import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { XCircle, ArrowLeft, Home, ShoppingBag } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl border border-slate-200 p-8 text-center shadow-lg">
          <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-10 w-10 text-red-600" />
          </div>
          <h1 className="font-heading text-2xl font-bold text-slate-900 mb-2" data-testid="payment-cancelled">
            Payment Cancelled
          </h1>
          <p className="text-slate-500 mb-8">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          <div className="flex flex-col gap-3">
            <Link to="/store">
              <Button className="w-full bg-indigo-600 hover:bg-indigo-700 rounded-full h-12" data-testid="back-to-store-btn">
                <ShoppingBag className="h-5 w-5 mr-2" />
                Back to Store
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full rounded-full h-12">
                <Home className="h-5 w-5 mr-2" />
                Return Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
